import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_patient_details = _resolveComponent("patient-details")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_patient_kins = _resolveComponent("patient-kins")!
  const _component_patient_othder_details = _resolveComponent("patient-othder-details")!
  const _component_patient_employment = _resolveComponent("patient-employment")!
  const _component_patient_insurance = _resolveComponent("patient-insurance")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        color: "primary",
        centered: "",
        stacked: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "tab-2",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Details ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-3",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Next of Kin ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-4",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" More Info ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-5",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Employment ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-6",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Insurance ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_window, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "tab-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_patient_details)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_patient_kins, { patient: _ctx.patient }, null, 8, ["patient"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_patient_othder_details)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_patient_employment, { patient: _ctx.patient }, null, 8, ["patient"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_patient_insurance, { patient: _ctx.patient }, null, 8, ["patient"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}